import { Allergen } from '@sg/graphql-schema';

import { INITIAL_ALLERGENS } from '../setup/context';
import { type AllergenTypes } from '../setup/types';
import { mergeKnownProperties } from './merge-known-properties';

// ─────────────────────────────────────────────────────────────────────────────

export function mergeRemoteAllergens(remoteAllergens: Allergen[] | readonly Allergen[]) {
  const preferences = [...remoteAllergens].reduce<Preferences>(addPreference, {});

  return mergeKnownProperties(INITIAL_ALLERGENS, preferences) as AllergenTypes;
}

// ─────────────────────────────────────────────────────────────────────────────

function addPreference(preferences: Preferences, preference: Allergen) {
  return { ...preferences, [preference]: true };
}

type Preferences = Partial<AllergenTypes>;
